module.exports = [{"type":"title","text":"2025-01-22"},{"type":"normal","text":"","style":{"font-weight":"bold"},"children":[{"type":"html","text":"永續U本位：所有下單相關接口增加Status字段"}]}]


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/changelog/2025-01-22.json
// module id = g2de
// module chunks = 3